import { render, staticRenderFns } from "./RegimenQuestionEdit.vue?vue&type=template&id=bcc720c2"
import script from "./RegimenQuestionEdit.vue?vue&type=script&lang=js"
export * from "./RegimenQuestionEdit.vue?vue&type=script&lang=js"
import style0 from "./RegimenQuestionEdit.vue?vue&type=style&index=0&id=bcc720c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports